import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../store/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../api/client/axios';
import { AxiosError } from 'axios';
import { buildListParams } from '../../dataHandlers/queryParams';
import { parseListResponse } from '../../dataHandlers/parseListResponse';

const fetchPartners = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await apiClient.get(`/partners`, { params });
  return data;
};

export const useGetPartnersHandler = ({ searchQuery = {} }) => {
  const dispatch = useDispatch();
  const [partners, setPartners] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const queryClient = useQueryClient();
  const listParams = buildListParams(searchQuery);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery(
    {
      queryKey: ['partners', listParams],
      cacheTime: 0,
      queryFn: fetchPartners,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: 'always',
    },
    queryClient,
  );

  useEffect(() => {
    if (fetchedData) {
      const { rows, total } = parseListResponse(fetchedData);
      setPartners(rows);
      setTotalDocuments(total);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    partners,
    totalDocuments,
    isLoading,
  };
};
